export const AUTH_USER = 'authenticate';
export const AUTH_REGISTER = 'register';
export const AUTH_LOGIN = 'login';
export const AUTH_ERROR = 'error';
export const AUTH_LOGOUT = 'logout';
